import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Dotdotdot from 'react-dotdotdot';
import PurchaseKeyInfo from '../../containers/purchase-key-info.container';
import PurchaseImage from '../../../containers/purchase-image.container';
import { SMALL_FOUR_THIRD } from '../../lib/image-versions';
import { truncate } from '../../lib/functions';
import '../../css/purchase-info.css';

class PurchaseInfo extends Component {
  renderHeading() {
    return (
      <div className="purchase-info-heading row mb-4">
        {this.renderImage()}
        {this.renderTitle()}
      </div>
    );
  }

  renderImage() {
    return (
      <div className="col-4">
        <PurchaseImage
          className="purchase-info-image img-fluid rounded"
          version={SMALL_FOUR_THIRD}
        />
      </div>
    );
  }

  renderTitle() {
    const { organizerUser, purchase: { product } } = this.props;
    const title = truncate(product.name, 45);
    return (
      <div className="purchase-info-title col-8">
        <p className="created-by cool-grey">
        <FormattedMessage
          id="purchaseInfo.createdBy"
          defaultMessage="Group created by {name} to purchase:"
          values={{ name: <b>{organizerUser.fullName}</b> }}
        />
        </p>
        <h1 title={title}><Dotdotdot clamp={2}>{title}</Dotdotdot></h1>
      </div>
    );
  }

  render() {
    return (
      <div className="purchase-info purchase-info-single-cost container">
        {this.renderHeading()}
        <PurchaseKeyInfo />
      </div>
    );
  }
}

export default PurchaseInfo;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/purchase-info.js